import { sleep } from './sleep';

/**
 * Retries a function until it succeeds or until cancelled.
 *
 * NOTE: If cancelled, the returned promise will never resolve!
 *
 * @template T The return type of the function that will be retried
 * @param {() => T} fn The function to retry
 * @param {() => boolean} cancelled A function that returns whether or not we should cancel
 * @return {*}  {Promise<T>}
 */
export function retryCancel<T>(fn: () => Promise<T>, cancelled: () => boolean | Promise<boolean>): Promise<T> {
    let timeout = 1000;
    return new Promise(async resolve => {
        while (!await cancelled()) {
            try {
                const result = await fn();
                if (await cancelled()) return;
                return resolve(result);
            } catch (e: unknown) {
                console.warn('retryCancel threw an error', e);
                await sleep(timeout);
                timeout = Math.min(15_000, timeout * 2);
            }
        }
    });
}
